<template>
  <div>
    <div v-for="(item, index) in listData" :key="`${level}-${index}`">
      <div>
        <v-card
          :style="`${
            item.searchActive
              ? 'background-color:#ffffc1;'
              : 'background-color:#ffffff;'
          }${cardMargin()}`"
          v-if="!loading"
          class="mb-2"
          outlined
        >
          <v-card-text class="pa-0">
            <v-row style="min-height: 60px">
              <v-col class="services-item-col">
                <v-btn
                  v-if="hasChildren(item)"
                  icon
                  @click="changeShowChildren(item)"
                >
                  <v-icon>{{
                    item.showChildren ? 'mdi-chevron-down' : 'mdi-chevron-right'
                  }}</v-icon>
                </v-btn>
                <v-icon v-else-if="childrenIcon(item)">mdi-circle-small</v-icon>
              </v-col>
              <v-col style="align-self: center" md="1">
                <v-tooltip max-width="300" v-if="checkAdded(item)" top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <el-checkbox
                        :disabled="checkAdded(item)"
                        :value="item.selected"
                        class="pt-0 mt-0"
                      >
                      </el-checkbox>
                    </div>
                  </template>
                  <span>{{
                    $t(
                      'Paslauga jau pridėta į pasirinktų paslaugų sąrašą! Jei norite keisti pasirinkimą, pirmiausia pašalinkite paslaugą iš pasirinktų paslaugų sąrašo.'
                    )
                  }}</span>
                </v-tooltip>
                <el-checkbox
                  v-else
                  @change="checkboxChange(item)"
                  class="mt-0 pt-0"
                  :value="item.selected"
                  :class="item.selected ? 'item-selected-active' : ''"
                />
                <!--  -->
              </v-col>
              <v-col cols="10" md="10">
                <v-row
                  @click="checkCheckbox(item)"
                  class="ma-0"
                  style="text-align: start"
                >
                  <v-col class="pa-0" cols="12" md="12"
                    ><span style="font-size: 1rem">{{ getLabel(item) }}</span
                    ><small>{{ getLabelCode(item) }}</small></v-col
                  >
                  <v-col class="pa-0" cols="12" md="12"
                    ><small
                      ><strong>{{ getSubLabel(item) }}</strong></small
                    ></v-col
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <institution-services-items
          v-if="item.showChildren"
          :level="getLevel()"
          :allData="allData"
          :formData="item.children"
          :activeServices="activeServices"
        />
      </div>
      <slot v-if="index == listData.length - 10"> </slot>
    </div>
  </div>
</template>

<script>
import Enums from '@/enums'

export default {
  name: 'InstitutionServicesItems',
  props: {
    // activeChildren: Boolean,
    formData: [Object, Array],
    allData: [Object, Array],
    level: Number,
    activeServices: Array,
  },
  data() {
    return {
      listData: [],
      pageloading: false,
      loading: false,
      selected: 0,
      mapList: []
    }
  },
  created() {
    this.listData = this.formData
    if(this.activeServices.length > 0){
      this.openActiveOnCreate(this.listData) 
    }
  },
  computed: {
    elValue: {
      get() {
        return this.listData
      },
      set(elValue) {
        this.$emit('formData', elValue)
      },
    },
  },

  methods: {
    openActiveOnCreate(itamArray){
      let logic = false
      itamArray.map((item) => {
        if (item.children.length > 0 ) {
          let childActive = this.openActiveOnCreate(item.children)
          childActive && this.$set(item, 'showChildren', true)
          return true
        } else if (this.activeServices.includes(item.id)) {
          // last level and active
          logic = true
        } 
      })
      return logic
    },
    checkAdded(item) {
      if (this.activeServices && this.activeServices.includes(item.id)) {
         this.$set(item, 'activeService', true)
         this.$set(item, 'selected', true)
        return true
      } else if(item.children.length > 0) {
        let activated = item.children.filter((item) => item.activeService).length
        let all = item.children.length
        if(all == activated) {
          this.$set(item, 'selected', true)
          this.$set(item, 'activeService', true)
          return true
        }
      }
       this.$set(item, 'activeService', false)
     return false
    },
    getLabelCode(item) {
      let code = ``
      item.code && (code += ` (${item.code || ''})`)
      item.pasis_code && (code += ` (${item.pasis_code || ''})`)
      return code
    },
    getLabel(item) {
      return this.$i18n.locale === 'lt' ? item.title_lt : item.title_en
    },
    getSubLabel(item) {
      let title = ''
      let provider_type = item.provider_type
      if (provider_type === 'amn') {
        title = item.institution?.fullname
      } else {
        title = this.$t(Enums.providerType[provider_type])
      }
      return title
    },
    hasChildren(item) {
      return item.children.length > 0
    },
    childrenIcon(item) {
      return item.parent_id
    },
    getLevel() {
      return this.level + 1
    },
    changeShowChildren(item) {
      let logic = !item.showChildren
      this.$set(item, 'showChildren', logic)
    },
    cardMargin() {
      let number = this.level >= 5 ? 5 : this.level
      let padding = (number - 1) * 20
      return `margin-left:${padding}px;width: 600px;`
    },
    deselect(items, itemArray) {
      items.map((item) => {
        if (itemArray && itemArray.includes(item.id)) {
          this.$set(item, 'selected', false)
        }
        this.deselect(item.children, itemArray)
      })
    },
    autoCheck(item, logic) {
      if (logic) {
        this.$set(item, 'showChildren', true)
        item.children.map((children) => {
          if (
            typeof children.mapArray === 'undefined' ||
            !Array.isArray(children.mapArray)
          ) {
            children.mapArray = []
          }

          if (item.mapArray) {
            children.mapArray = [...children.mapArray, ...item.mapArray]
          } else {
            children.mapArray = []
          }

          children.mapArray.push(item.id)
          this.$set(children, 'selected', true)
          this.autoCheck(children, logic)
        })
      } else {
        // if all selected
        if(this.checkAllSelected(item)){
          return
        }
        // else
        this.deselect(this.allData, item.mapArray)
      }
    },
    checkAllSelected(item){
      item.children.map((children) => {
        if(!children.selected){
          return true
        }
        this.checkAllSelected(children)
      })
      // deselect all
      item.children.map((children) => {
        this.$set(children, 'selected', false)
        this.checkAllSelected(children)
      })
      return false
    },
    checkboxChange(item) {
      let logic = !item.selected
      this.$set(item, 'selected', logic)
      this.autoCheck(item, logic)
    },
    checkCheckbox(item) {
      let logic = !item.selected
      this.$set(item, 'selected', logic)
      this.autoCheck(item, logic)
    },
  },
}
</script>

<style lang="scss" scoped></style>
